import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7, default as _styled8 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
/* istanbul ignore file */

import React from 'react';
import { withScopedBaseStyles } from '@noths/polaris-client-ribbons-base';
import * as styles from "./Footer.styles";
import { FooterAppPromo } from "../../molecules/FooterAppPromo/FooterAppPromo";
import { FooterLegal } from "../../molecules/FooterLegal/FooterLegal";
import { FooterLinks } from "../../molecules/FooterLinks/FooterLinks";
import { FooterPayment } from "../../molecules/FooterPayment/FooterPayment";
import { FooterSocialMedia } from "../../molecules/FooterSocialMedia/FooterSocialMedia";
import { LocalePanel } from "../../molecules/LocalePanel/LocalePanel";
import { NewsletterSignUpForm } from "../../molecules/NewsletterSignUpForm/NewsletterSignUpForm";
import { useSiteChromeStaticContext } from "../../../context/SiteChromeStaticContext/useSiteChromeStaticContext";
var FooterComponent = function FooterComponent() {
  var _useSiteChromeStaticC = useSiteChromeStaticContext(),
    env = _useSiteChromeStaticC.env;
  return /*#__PURE__*/React.createElement("footer", null, /*#__PURE__*/React.createElement(_StyledSection, {
    $_css: [styles.footerSections, styles.firstSection]
  }, /*#__PURE__*/React.createElement(NewsletterSignUpForm, {
    env: env
  })), /*#__PURE__*/React.createElement(_StyledSection2, {
    $_css2: [styles.footerSections, styles.secondSection]
  }, /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css3: styles.footerInner
  }, /*#__PURE__*/React.createElement(_StyledDiv2, {
    $_css4: styles.appSection
  }, /*#__PURE__*/React.createElement(FooterAppPromo, null), /*#__PURE__*/React.createElement(FooterSocialMedia, null)), /*#__PURE__*/React.createElement(FooterLinks, null), /*#__PURE__*/React.createElement(_StyledDiv3, {
    $_css5: styles.paymentSection
  }, /*#__PURE__*/React.createElement(_StyledDiv4, {
    $_css6: styles.localePanel
  }, /*#__PURE__*/React.createElement(LocalePanel, {
    buttonStyles: styles.localePanelButton,
    flagStyles: styles.localePanelFlag,
    headingStyles: styles.localePanelHeading,
    placement: "footer"
  })), /*#__PURE__*/React.createElement(FooterPayment, null)))), /*#__PURE__*/React.createElement(_StyledSection3, {
    $_css7: [styles.footerSections, styles.thirdSection]
  }, /*#__PURE__*/React.createElement(_StyledDiv5, {
    $_css8: styles.footerInner
  }, /*#__PURE__*/React.createElement(FooterLegal, null))));
};
export var Footer = withScopedBaseStyles(FooterComponent);
var _StyledSection = _styled("section")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledSection2 = _styled2("section")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledDiv = _styled3("div")(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css3;
});
var _StyledDiv2 = _styled4("div")(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css4;
});
var _StyledDiv3 = _styled5("div")(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css5;
});
var _StyledDiv4 = _styled6("div")(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css6;
});
var _StyledSection3 = _styled7("section")(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css7;
});
var _StyledDiv5 = /*#__PURE__*/_styled8("div").withConfig({
  displayName: "Footer___StyledDiv5",
  componentId: "sc-tzyn6c-0"
})(["", ""], function (p) {
  return p.$_css8;
});